import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const FormattedAmountInput = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  input {
    text-align: center;
    ${theme.textStyles['text-preset-2']};
    border: none;
    box-shadow: inset 0 -1px 0 ${theme.colors.neutral.border.regular};
    padding-top: ${theme.spacing['spacing-6']};
    padding-bottom: ${theme.spacing['spacing-3']};
    color: ${theme.colors.neutral.text.strong};

    &:focus {
      outline: none;
      border: none;
      box-shadow: inset 0 -1px 0 ${theme.colors['secondary-1'].border.regular};
      caret-color: ${theme.colors['secondary-1'].border.regular};
    }

    ${({ status }) =>
      status === 'error' &&
      css`
        border: none;
        box-shadow: inset 0 -1px 0 ${theme.colors.danger.border.regular};
        &:focus {
          outline: none;
          border: none;
          box-shadow: inset 0 -1px 0 ${theme.colors.danger.border.regular};
          caret-color: ${theme.colors.danger.border.regular};
        }
      `}

    &::placeholder {
      color: ${theme.colors.neutral.text.regular};
    }
  }
`;

export const HelpText = styled.div`
  padding-top: ${theme.spacing['spacing-3']};
  display: flex;
  justify-content: center;
  ${({ status }) =>
    status === 'error' &&
    css`
      > * {
        &:first-child {
          margin-right: ${theme.spacing['spacing-2']};
        }
      }
    `}
`;
